import React from 'react';
import PropTypes from 'prop-types';
import StackItem from 'components/Misc/StackItem';
import DraggableList from 'react-draggable-list';

/**
 * @param {any} Props
 */
const StackItemsView = ({
  stack = [],
  onDeleteItem,
  onEditItem,
  onClickedItem,
  describeItem,
  additionalButton,
  getAdditionalElement,
  hideStatus = false,
  onMoveEnd,
  itemKey,
}) =>
  stack.length > 0 ? (
    <div className="stack">
      {!!onMoveEnd ? (
        <DraggableList
          onMoveEnd={onMoveEnd}
          list={stack}
          padding={0}
          itemKey={itemKey || 'id'}
          commonProps={{
            onDeleteItem,
            onEditItem,
            onClickedItem,
            describeItem,
            additionalButton,
            hideStatus,
            draggable: !!onMoveEnd,
            getAdditionalElement,
          }}
          template={StackItemWrapper}
        />
      ) : (
        stack.map((item) => (
          <StackItem
            text={describeItem ? describeItem(item) : item.value}
            added={item.id === undefined && !hideStatus}
            edited={item.id !== undefined && !hideStatus}
            deleted={item.action === 'delete' && !hideStatus}
            rotated={item.action === 'rotation' && !hideStatus}
            onDelete={onDeleteItem ? () => onDeleteItem(item) : null}
            onEdit={onEditItem ? () => onEditItem(item) : null}
            additionalButton={additionalButton ? additionalButton(item) : null}
            onClick={!!onClickedItem ? () => onClickedItem(item) : null}
            draggable={!!onMoveEnd}
            additionalElement={getAdditionalElement ? getAdditionalElement(item) : null}
          />
        ))
      )}
    </div>
  ) : null;

class StackItemWrapper extends React.Component {
  render() {
    const { item, dragHandleProps, commonProps } = this.props;

    const {
      describeItem,
      hideStatus,
      onDeleteItem,
      onEditItem,
      additionalButton,
      onClickedItem,
      draggable,
      getAdditionalElement,
    } = commonProps;

    return (
      <StackItem
        text={describeItem ? describeItem(item) : item.value}
        added={item.id === undefined && !hideStatus}
        edited={item.id !== undefined && !hideStatus}
        deleted={item.action === 'delete' && !hideStatus}
        rotated={item.action === 'rotation' && !hideStatus}
        onDelete={onDeleteItem ? () => onDeleteItem(item) : null}
        onEdit={onEditItem ? () => onEditItem(item) : null}
        additionalButton={additionalButton ? additionalButton(item) : null}
        onClick={!!onClickedItem ? () => onClickedItem(item) : null}
        draggable={draggable}
        dragHandleProps={dragHandleProps}
        additionalElement={getAdditionalElement ? getAdditionalElement(item) : null}
      />
    );
  }
}

StackItemsView.propTypes = {
  stack: PropTypes.array,
  onDeleteItem: PropTypes.func,
  describeItem: PropTypes.func,
  onEditItem: PropTypes.func,
  additionalButton: PropTypes.func,
  getAdditionalElement: PropTypes.func,
  hideStatus: PropTypes.bool,
  onMoveEnd: PropTypes.func,
  onClickedItem: PropTypes.func,
  itemKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

export default StackItemsView;
